import React, { FC } from 'react';
import i18n from '../../i18n';
import { getBundleListTotal } from '../../utils/material/material-helper';
import './pages-info.scss';

type PagesInfoProps = {
    item: Material;
};
const PagesInfo: FC<PagesInfoProps> = ({ item }) => {
    return (
        <div>
            {Boolean(!item.bundle && item.totalPages > 0) && (
                <div className='pages-info-container text-center text-muted'>
                    <div className='pages-info'>
                        {item.totalPages}{' '}
                        <span>
                            {/* @ts-ignore */}
                            {item.totalPages === 1
                                ? i18n.t('common:common.materialPreview.page', { count: item.totalPages })
                                : i18n.t('common:common.materialPreview.page_plural', { count: item.totalPages })}
                        </span>
                    </div>
                </div>
            )}
            {Boolean(item.bundle && getBundleListTotal(item)) && (
                <div className='bundle-pages-info-container text-center text-muted'>
                    <div className='pages-info'>
                        {/* @ts-ignore */}
                        {i18n.t('common:common.materialPreview.materials', { number: getBundleListTotal(item) })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PagesInfo;
